import { render, staticRenderFns } from "./FlowCanvas.vue?vue&type=template&id=875d39cc&scoped=true&"
import script from "./FlowCanvas.vue?vue&type=script&lang=js&"
export * from "./FlowCanvas.vue?vue&type=script&lang=js&"
import style0 from "./FlowCanvas.vue?vue&type=style&index=0&id=875d39cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "875d39cc",
  null
  
)

export default component.exports